'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Avatar/Avatar.js');
require('../../DataDisplays/Label/Label.js');
var SystemIcon = require('../../DataDisplays/SystemIcon/SystemIcon.js');

const TextFieldContainer = ({ children, className, leadingIcon, trailingIcon, isLeadingIconSolid, isTrailingIconSolid, measure, isFocused, isDisabled, isError, onClick, isTextarea, isAutoComplete, testId })=>{
    const generateBorderColor = ()=>{
        if (isDisabled) return 'border-w-gray-200';
        if (isError) return 'border-w-red-500';
        if (isFocused) return 'border-primary';
        return 'border-w-gray-200 hover:border-primary';
    };
    const generateBackgroundColor = ()=>{
        if (isDisabled) return 'bg-w-gray-10';
        return 'bg-w-white';
    };
    return jsxRuntime.jsxs(Box, {
        className: tailwindMerge.twMerge('group flex w-full items-center gap-3 overflow-hidden rounded-xl border px-4 py-[11px]', generateBorderColor(), generateBackgroundColor(), isDisabled && 'cursor-not-allowed', isTextarea && 'relative p-0', isAutoComplete && 'flex-wrap', className),
        "data-testid": testId || 'design-system--text-field-container',
        onClick: onClick,
        children: [
            leadingIcon && jsxRuntime.jsx(SystemIcon, {
                name: leadingIcon,
                solid: isLeadingIconSolid,
                className: tailwindMerge.twMerge('shrink-0 text-w-gray-600', isDisabled && 'text-w-gray-300'),
                testId: "design-system--text-field-container-leading-icon"
            }),
            children,
            measure && jsxRuntime.jsx(Typography, {
                variant: "body1",
                className: tailwindMerge.twMerge('w-fit shrink-0 text-w-gray-400', isDisabled && 'text-w-gray-300'),
                children: measure
            }),
            trailingIcon && jsxRuntime.jsx(SystemIcon, {
                name: trailingIcon,
                solid: isTrailingIconSolid,
                className: tailwindMerge.twMerge('shrink-0 text-w-gray-600', isDisabled && 'text-w-gray-300'),
                testId: "design-system--text-field-container-trailing-icon"
            })
        ]
    });
};

module.exports = TextFieldContainer;
